import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { AppDispatch, RootReducerType } from "@store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getDocumentsListThunk,
  getUploadedFileByIdThunk,
} from "@modules/stepper-row/redux/thunk/documentThunk";
import UndertakingList from "@modules/stepper-row/components/UndertakingList";
import { saveRowUndertakingThunk } from "@modules/stepper-row/redux/thunk/documentThunk";
import { UnderTakingConsentRow } from "@modules/stepper-row/components/UnderTakingConsentRow";

export const Consent: React.FC<{
  isExpanded: boolean;
  toggleExpand: () => void;
  consentCheck?: boolean;
  data: any;
  setConsentCheck?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isExpanded, toggleExpand, data }) => {

  return (
    <Box>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9", p: 0 }}>
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 2,
            borderBottom: "1px solid #E7E8E9",
          }}
        >
          <Typography
            className="preview-dropdown-header"
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
          >
            Undertakings & Consents
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
        {isExpanded && (
          <>
            <UnderTakingConsentRow collapsed isDetailsPage={true} data={data} />
          </>
        )}
      </Card>
    </Box>
  );
};
